(ns ui.openrouter.catalog
  "Pure helpers for the OpenRouter model catalog shown in the editor2
   AI sidebar."
  (:require [clojure.string :as str]))

(def models-query
  {:query/kind :query/openrouter-models})

(defn matches?
  [search model]
  (let [needle (str/lower-case (str/trim search))]
    (or (str/includes? (str/lower-case (or (:model/name model) ""))
                       needle)
        (str/includes? (str/lower-case (or (:model/id model) ""))
                       needle)
        (str/includes? (str/lower-case (or (:model/description model) ""))
                       needle))))

(defn filter-categories
  "Filters the models of each category by the search string and drops
   categories without matches. A blank search returns the categories
   unchanged."
  [categories search]
  (if (str/blank? search)
    categories
    (->> categories
         (map (fn [category]
                (update category
                        :category/models
                        (fn [models]
                          (filterv (partial matches? search)
                                   models)))))
         (filterv (fn [category]
                    (seq (:category/models category)))))))

(def collapsed-count
  "Number of models shown per category while it is collapsed: the two
   badged picks plus the three cheapest others."
  5)

(defn visible-models
  [models expanded?]
  (if expanded?
    models
    (take collapsed-count models)))
